:host(:not(.inside-dialog)) {
  .component {
    border-top: $border-width solid $color-gray-tint-6;
    border-bottom: $border-width solid $color-gray-tint-6;

    .name {
      padding: 0 $select-inner-margin;
      border-left: $border-width solid $color-gray-tint-6;
      border-right: $border-width solid $color-gray-tint-6;
    }

    &.sdx--dark-theme {
      border-top-color: $color-gray-tint-7-dark-theme;
      border-bottom-color: $color-gray-tint-7-dark-theme;

      .name {
        border-left-color: $color-int-blue2-dark-theme;
        border-right-color: $color-int-blue2-dark-theme;
      }
    }
  }
}

:host {
  display: block;

  ::slotted(sdx-select-option) {
    border-top: none;
    border-bottom: none;
  }

  // Indent grouped options.
  // Not needed when checkbox or radio elements are visible and provides indentation-like effect
  ::slotted(sdx-select-option:not(.multiple):not(.inside-dialog)) {
    padding-left: $baseline-2;
  }

  .component {
    &.top {
      border-top: none;
    }

    &.bottom {
      border-bottom: none;
    }

    .name {
      @include font-semi-bold;
      display: flex;
      align-items: center;
      white-space: nowrap;
      height: $select-height;
    }
  }
}
